<div class="showcase-grid">
  <div class="showcase-row" data-showcase-id="cs-input">
    <cs-label>cs-input: rest, disabled, error</cs-label>
    <div class="showcase-variants">
      <cs-input [value]="sampleText" (valueChange)="sampleTextChange.emit($event)" [placeholder]="'Rest' | untranslated"></cs-input>
      <cs-input [value]="'Disabled'" [disabled]="true"></cs-input>
      <cs-input error [value]="'Error'"></cs-input>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-input-measure">
    <cs-label>cs-input-measure: rest, readonly (no outline), disabled</cs-label>
    <div class="showcase-variants">
      <cs-input-measure [(canonValue)]="outlineMeasure" type="skinfold_mm" />
      <cs-input-measure [canonValue]="12" type="skinfold_mm" [readonly]="true" />
      <cs-input-measure [canonValue]="12" type="skinfold_mm" [disabled]="true" />
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-input-time">
    <cs-label>cs-input-time: rest, disabled</cs-label>
    <div class="showcase-variants">
      <cs-input-time [(time)]="outlineTime"></cs-input-time>
      <cs-input-time [time]="outlineTime" [disabled]="true"></cs-input-time>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-select">
    <cs-label>cs-select: rest, disabled</cs-label>
    <div class="showcase-variants">
      <cs-select [(value)]="outlineSelect" [ariaLabel]="'Sample select'">
        <cs-select-option value="a" [label]="'Option A' | untranslated"></cs-select-option>
        <cs-select-option value="b" [label]="'Option B' | untranslated"></cs-select-option>
      </cs-select>
      <cs-select [value]="'a'" [disabled]="true" [ariaLabel]="'Disabled select'">
        <cs-select-option value="a" [label]="'Option A' | untranslated"></cs-select-option>
      </cs-select>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-textarea">
    <cs-label>cs-textarea: rest, disabled</cs-label>
    <cs-textarea [(value)]="outlineNotes" [placeholder]="'Notes' | untranslated" [rows]="3"></cs-textarea>
    <cs-textarea [value]="'Disabled'" [disabled]="true" [rows]="2"></cs-textarea>
  </div>

  <div class="showcase-row" data-showcase-id="input-calendar">
    <cs-label>input-calendar (tap to open the calendar page, its field uses the same outline)</cs-label>
    <div class="showcase-variants">
      <input-calendar [date]="sampleDate" (dateChange)="sampleDateChange.emit($event)" [placeholder]="datePlaceholder" />
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-segment">
    <cs-label>cs-segment + cs-segment-button: rest, disabled</cs-label>
    <cs-segment [(selection)]="outlineSegment">
      <cs-segment-button value="day">Day</cs-segment-button>
      <cs-segment-button value="week">Week</cs-segment-button>
      <cs-segment-button value="month">Month</cs-segment-button>
    </cs-segment>
    <cs-segment [selection]="'day'" [disabled]="true">
      <cs-segment-button value="day">Day</cs-segment-button>
      <cs-segment-button value="week">Week</cs-segment-button>
    </cs-segment>
  </div>

  <div class="showcase-row" data-showcase-id="cs-radio">
    <cs-label>cs-radio: unchecked, checked, disabled</cs-label>
    <cs-radio-group [(selected)]="outlineRadio">
      <cs-radio [value]="'one'">Unchecked until picked</cs-radio>
      <cs-radio [value]="'two'">Checked</cs-radio>
      <cs-radio [value]="'three'" [disabled]="true">Disabled</cs-radio>
    </cs-radio-group>
  </div>

  <div class="showcase-row" data-showcase-id="cs-radio-intake">
    <cs-label>cs-radio with note, badge and alert (as in the intake form)</cs-label>
    <cs-radio-group [(selected)]="complexRadio">
      <cs-radio [value]="'slow'" [recommended]="true">
        Slow and Steady
        <cs-note>Fewer sets per week. Easier to recover from and fit into a busy schedule.</cs-note>
      </cs-radio>
      <cs-radio [value]="'balanced'">
        Balanced
        <cs-note>A moderate number of sets for steady progress.</cs-note>
      </cs-radio>
      <cs-radio [value]="'max'">
        Maximum Effort
        <cs-note>The most sets per week. Needs good sleep, food and recovery to pay off.</cs-note>
        <cs-text-alert type="warning">This volume may be more than you can recover from.</cs-text-alert>
      </cs-radio>
      <cs-radio [value]="'off'" [disabled]="true">
        Disabled With Note
        <cs-note>Shown but not selectable, like a split the user does not train often enough for.</cs-note>
      </cs-radio>
    </cs-radio-group>
  </div>

  <div class="showcase-row" data-showcase-id="cs-radio-custom-content">
    <cs-label>cs-radio with custom content (as on the subscribe page's plan cards)</cs-label>
    <cs-radio-group [(selected)]="planRadio" class="showcase-plan-radios">
      <cs-radio [value]="'monthly'">
        <div custom-content class="plan-content">
          <span class="plan-name">Monthly</span>
          <span class="plan-price">$9.99</span>
        </div>
      </cs-radio>
      <cs-radio [value]="'yearly'">
        <div custom-content class="plan-content">
          <span class="plan-name">Yearly</span>
          <span class="plan-price">$79.99</span>
        </div>
      </cs-radio>
    </cs-radio-group>
  </div>

  <div class="showcase-row" data-showcase-id="cs-radio-table-row">
    <cs-label>cs-radio in a table row (as in equipment search and exercise switch)</cs-label>
    <cs-radio-group [(selected)]="tableRadio">
      <cs-table class="showcase-radio-table">
        <cs-table-row clickable (rowClick)="tableRadio = 'barbell'">
          <cs-table-cell class="radio-cell">
            <cs-radio [value]="'barbell'"></cs-radio>
          </cs-table-cell>
          <cs-table-cell class="info-cell">
            <div class="row-name">Barbell</div>
          </cs-table-cell>
        </cs-table-row>
        <cs-table-row clickable (rowClick)="tableRadio = 'dumbbells'">
          <cs-table-cell class="radio-cell">
            <cs-radio [value]="'dumbbells'"></cs-radio>
          </cs-table-cell>
          <cs-table-cell class="info-cell">
            <div class="row-name">Adjustable Dumbbells With A Long Name That Wraps Onto A Second Line</div>
          </cs-table-cell>
        </cs-table-row>
      </cs-table>
    </cs-radio-group>
  </div>

  <div class="showcase-row" data-showcase-id="markdown-editor">
    <cs-label>markdown-editor (edit mode)</cs-label>
    <markdown-editor [data]="outlineMarkdown" (updateData)="outlineMarkdown = $event"></markdown-editor>
  </div>

  <div class="showcase-row" data-showcase-id="cs-button-secondary">
    <cs-label>cs-button secondary: rest, disabled, active</cs-label>
    <div class="showcase-variants">
      <cs-button small secondary [label]="'Rest' | untranslated"></cs-button>
      <cs-button small secondary [disabled]="true" [label]="'Disabled' | untranslated"></cs-button>
      <cs-button small secondary aria-pressed="true" [label]="'Active' | untranslated"></cs-button>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-button-tinted">
    <cs-label>cs-button tinted: rest, disabled, with an endIcon, full width</cs-label>
    <div class="showcase-variants">
      <cs-button tinted [label]="'Rest' | untranslated"></cs-button>
      <cs-button tinted [disabled]="true" [label]="'Disabled' | untranslated"></cs-button>
      <cs-button tinted icon="time" endIcon="play" [label]="'Rest Timer · 2:00' | untranslated"></cs-button>
      <cs-button tinted fit-width icon="time" endIcon="play" [label]="'Rest Timer · 2:00' | untranslated"></cs-button>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-bar-button">
    <cs-label>cs-bar-button: rest, disabled</cs-label>
    <div class="showcase-variants showcase-bar">
      <cs-bar-button icon="info" [label]="'Instructions' | untranslated"></cs-bar-button>
      <cs-bar-button icon="time" [label]="'History' | untranslated"></cs-bar-button>
      <cs-bar-button icon="edit" [label]="'Disabled' | untranslated" [disabled]="true"></cs-bar-button>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-bar-button-compact">
    <cs-label>cs-bar-button compact (the workout card's Instructions / History): rest, disabled</cs-label>
    <div class="showcase-variants showcase-bar">
      <cs-bar-button compact [label]="'Instructions' | untranslated"></cs-bar-button>
      <cs-bar-button compact [label]="'History' | untranslated"></cs-bar-button>
      <cs-bar-button compact [label]="'Disabled' | untranslated" [disabled]="true"></cs-bar-button>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-icon-button-outlined">
    <cs-label>cs-icon-button outlined: rest, disabled</cs-label>
    <div class="showcase-variants">
      <cs-icon-button outlined class="showcase-outlined-icon" icon="add" [ariaLabel]="'Add' | untranslated"></cs-icon-button>
      <cs-icon-button outlined disabled class="showcase-outlined-icon" icon="add" [ariaLabel]="'Disabled' | untranslated"></cs-icon-button>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-icon-button-toggle">
    <cs-label>cs-icon-button toggle (pressed): off, on, and the status bell with one hidden message</cs-label>
    <div class="showcase-variants">
      <cs-icon-button small icon="information-circle" [fill]="false" [pressed]="false" [ariaLabel]="'Set instructions' | untranslated"></cs-icon-button>
      <cs-icon-button small icon="information-circle" [fill]="true" [pressed]="true" [ariaLabel]="'Set instructions' | untranslated"></cs-icon-button>
      <cs-icon-button small icon="notifications" [badge]="1" [badgeMinimum]="1" [ariaLabel]="'Notifications' | untranslated"></cs-icon-button>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="dividers">
    <cs-label>Dividers: cs-item-divider and cs-content-divider ($border-tertiary)</cs-label>
    <cs-item-list>
      <cs-item><cs-label>Item above the divider</cs-label></cs-item>
      <cs-item-divider>Section</cs-item-divider>
      <cs-item><cs-label>Item below the divider</cs-label></cs-item>
    </cs-item-list>
    <cs-content-divider></cs-content-divider>
  </div>
</div>
